import {
  Stack,
  TextField,
  useTheme,
  Button,
  Container,
  Typography,
  Paper,
  Grid,
  Dialog,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  IconButton,
  DialogTitle,
  DialogActions,
  Snackbar,
  Alert,
  LinearProgress,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
  FormControl,
  Chip,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Slide from '@mui/material/Slide';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import styled from '@emotion/styled';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddLocationAltRoundedIcon from '@mui/icons-material/AddLocationAltRounded';
import axios from '../../axiosConfig';
import './animation.css';

// table header cell styles
const StyledTableCell = styled(TableCell)({
  color: '#424242',
  fontWeight: '600',
  // textAlign: 'center',
});

const GarmentCategoryMst = () => {
  const [tokent, settokent] = useState(
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ'
  );
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [open, setOpen] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  // handle snackbar & alert messages on save
  const [openAlert, setopenAlert] = useState(false);
  // At the beginning of the component
  const [openDelete, setOpenDelete] = useState(false);
  const [stateIdToDelete, setStateIdToDelete] = useState(null);
  const [GarmentTypeData, setGarmentTypeData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');

  const [GarmentTypeDescription, setGarmentTypeDescription] = useState('');
  const [Active, setActive] = useState('Y');

  const [operation, setOperation] = useState('Add');
  const [editID, setEditID] = useState();
  const [errors, setErrors] = useState({
    GarmentTypeDescription: false,
    Active: false,
  });
  const [helperTexts, setHelperTexts] = useState({
    GarmentTypeDescription: '',
    Active: '',
  });
  // alert messages on operations
  const [alertType, setAlertType] = useState('success'); // 'success' or 'error'
  const [alertMessage, setAlertMessage] = useState('');

  const [openLoader, setOpenLoader] = useState(false);

  // API Integration
  useEffect(() => {
    GetGarmentTypeData();
  }, []);

  // get all states Request
  const GetGarmentTypeData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllGarmentTypeMstData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setGarmentTypeData(res.data);
      console.log(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // post Request to Add state
  const AddGarmentTypeData = async (newState) => {
    try {
      const res = await axios.instance.post('/InsertGarmentTypeMstData', newState, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      GetGarmentTypeData();
      setAlertType('success');
      setAlertMessage(' Added, Successfully!');
      setopenAlert(true); // Show a success message using the Snackbar
      setopenAlert(true); // Show a success message using the Snackbar
    } catch (error) {
      console.error('Error adding state:', error);
      setAlertType('error');
      setAlertMessage('Failed to add the state.');
      setopenAlert(true);
    }
  };

  // put Request to edit state

  const updateState = async (stateId, updatedState) => {
    try {
      await axios.instance.post(`/InsertGarmentTypeMstData`, updatedState, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setopenAlert(true);
      setEditID();
      GetGarmentTypeData();
      setAlertType('success');
      setAlertMessage(' Updated  Successfully!');
      setopenAlert(true);
    } catch (error) {
      console.error('Error updating state:', error);
      setAlertType('error');
      setAlertMessage('Failed to update the state.');
      setopenAlert(true);
    }
  };

  // delete Request to delete state
  const deleteState = async (stateId) => {
    try {
      await axios.instance
        .delete(`/DeleteGarmentTypeMstData/${stateId}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        })
        .then((res) => {
          if (res.data === '') {
            GetGarmentTypeData();
            setOpenDelete(false);
            setAlertType('warning');
            setAlertMessage(' Deleted Successfully!');
            setopenAlert(true);
          } else {
            GetGarmentTypeData();
            setOpenDelete(false);
            setAlertType('error');
            setAlertMessage("Oops! Can't delete this data. It's connected to other information.");
            setopenAlert(true);
          }
          console.log(res.data);
        });
    } catch (error) {
      console.error('Error deleting state:', error);
      setAlertType('error');
      setAlertMessage('Failed to delete .');
      setopenAlert(true);
    }
  };

  // submit button on add or edit
  const handleSubmit = (event) => {
    event.preventDefault();

    if (!GarmentTypeDescription) {
      setErrors((prevErrors) => ({ ...prevErrors, GarmentTypeDescription: true }));
      setHelperTexts((prevHelperTexts) => ({
        ...prevHelperTexts,
        GarmentTypeDescription: 'Please enter garment category',
      }));
    }

    if (!Active) {
      setErrors((prevErrors) => ({ ...prevErrors, Active: true }));
      setHelperTexts((prevHelperTexts) => ({
        ...prevHelperTexts,
        Active: 'Please select Active Status',
      }));
    }

    if (errors.GarmentTypeDescription || !GarmentTypeDescription) {
      setIsFormSubmitted(true);
      return;
    }

    const newState = {
      optype: operation === 'Edit' ? 'Edit' : 'New',
      Garment_TypeDescription: GarmentTypeDescription,
      Active,
      CreatedBy: sessionStorage.getItem('UserID'),
    };

    const editState = {
      optype: operation === 'Edit' ? 'Edit' : 'New',
      Garment_TypeId: editID,
      Garment_TypeDescription: GarmentTypeDescription,
      Active,
      ModifyedBy: sessionStorage.getItem('UserID'),
    };

    if (operation === 'Add') {
      AddGarmentTypeData(newState);
    } else if (operation === 'Edit') {
      console.log(editID, editState);
      updateState(editID, editState);
      // AddGarmentTypeData(editID, editState)
    }
    setGarmentTypeDescription('');
    handleClose();
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'GarmentTypeDescription') setGarmentTypeDescription(value);
    if (name === 'Active') setActive(value);
    // setGarmentTypeDescription(value);
    validateInput(name, value);
  };

  // validations
  const validateInput = (name, value) => {
    let error = false;
    let helperText = '';

    const locationRegex = /^[A-Za-z\s]+$/;
    const editedStateName = value.toLowerCase().trim();

    const isStateExistsinEDIt = GarmentTypeData.some(
      (obj) =>
        obj.Garment_TypeDescription.toLowerCase() === editedStateName.toLowerCase() && obj.Garment_TypeId !== editID
    );

    const isStateExists = GarmentTypeData.some((obj) => obj.Garment_TypeDescription.toLowerCase() === editedStateName);

    console.log(isStateExists, isStateExistsinEDIt, 'Name');

    if (name === 'GarmentTypeDescription') {
      if (!value.trim()) {
        // If the field is empty, show a different message
        error = true;
        helperText = 'Garment Category cannot be empty';
        setIsFormSubmitted(false);
      } else if (!locationRegex.test(value)) {
        // If the field has a value but doesn't match the regex
        error = true;
        helperText = 'Please enter a valid GarmentType';
        setIsFormSubmitted(false);
      } else if (operation === 'Add' && isStateExists) {
        error = true;
        helperText = 'GarmentType exists. Please enter a different GarmentType.';
        setIsFormSubmitted(false);
      } else if (operation === 'Edit' && isStateExistsinEDIt) {
        error = true;
        helperText = 'GarmentType  exists. Please enter a different GarmentType.';
        setIsFormSubmitted(false);
      } else if (name === 'Active') {
        if (!value.trim()) {
          error = true;
          helperText = 'Plaese select user status';
          setIsFormSubmitted(false);
        } else {
          setIsFormSubmitted(true);
        }
      }
    }

    // Update the errors and helperTexts states correctly
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
    setHelperTexts((prevHelperTexts) => ({
      ...prevHelperTexts,
      [name]: helperText,
    }));
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;
    if (value.length > 0) {
      validateInput(name, value);
    }
  };

  // handle edit popup dialog
  const handleAddOpen = () => {
    setOpen(true);
    setOperation('Add');
  };

  // handle edit popup dialog
  const handleEdit = (datas) => {
    setEditID(datas.Garment_TypeId);
    setActive(datas.Active);
    setGarmentTypeDescription(datas.Garment_TypeDescription);
    // console.log(state.StateId, state.StateName);
    handleEditOpen();
  };
  const handleEditOpen = () => {
    setOpen(true);
    setOperation('Edit');
  };

  // handle delete popup dialog
  const handleDelete = (stateId) => {
    setOpenDelete(true);
    setStateIdToDelete(stateId);
  };

  const handleDeleteConfirmed = (stateId) => {
    deleteState(stateId);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
    setopenAlert(false);
  };

  const handleCloseAlert = () => {
    setopenAlert(false);
  };

  const handleClose = () => {
    setOpen(false);
    setActive('Y');
    setGarmentTypeDescription('');
    errors.GarmentTypeDescription = false;
    errors.Active = false;
    helperTexts.GarmentTypeDescription = '';
    helperTexts.Active = '';
  };

  // search & filter

  const filteredData = GarmentTypeData.filter((c) =>
    c.Garment_TypeDescription.toLowerCase().includes(searchTerm.toLowerCase())
  );
  // pagination
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, filteredData.length - page * rowsPerPage);
  const totalRows = filteredData.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  // const currentPage = Math.min(page, totalPages - 1);
  const currentPage = Math.max(0, Math.min(page, totalPages - 1)); // Clamp to the range [0, totalPages - 1]
  // Reset page to 0 when searchTerm changes
  useEffect(() => {
    setPage(0);
  }, [searchTerm]);

  return (
    <>
      <Snackbar
        style={{ marginTop: '45px' }}
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={(props) => <Slide {...props} direction={'right'} />}
      >
        <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      <Container maxWidth={'xl'} elevation={3}>
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              background: 'linear-gradient(to right, #314755, #26a0da)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Garment Category Master
            </Typography>
          </Typography>
        </Grid>

        {/* search & add button */}
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} spacing={2} my={2}>
          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label="Search"
            size="small"
            onChange={(e) => setSearchTerm(e.target.value)}
            value={searchTerm}
          />
          <Button
            variant="outlined"
            color="secondary"
            sx={{ boxShadow: 1 }}
            onClick={handleAddOpen}
            startIcon={<AddLocationAltRoundedIcon />}
          >
            Add Garment Category
          </Button>
        </Stack>

        {/* table  */}
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <StyledTableCell align="center">S.No</StyledTableCell>
                <StyledTableCell align="left">Garment Category</StyledTableCell>
                <StyledTableCell align="center">Active</StyledTableCell>
                <StyledTableCell align="center">Actions</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0
                ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : filteredData
              ).map((state, index) => (
                <TableRow key={state.Garment_TypeId} hover>
                  <TableCell align="center">{state.SNo}</TableCell>
                  <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
                    {state.Garment_TypeDescription}
                  </TableCell>
                  <TableCell align="center">
                    {state.Active === 'Y' ? (
                      <Chip icon={<CheckCircleOutlineIcon />} color="success" size="small" label="Active" />
                    ) : (
                      <Chip icon={<HighlightOffIcon />} color="error" size="small" label="InActive" />
                    )}
                  </TableCell>
                  <TableCell align="center" sx={{ padding: '0' }}>
                    <IconButton aria-label="Edit" onClick={() => handleEdit(state)}>
                      <EditIcon color="primary" />
                    </IconButton>
                    <IconButton aria-label="Delete" onClick={() => handleDelete(state.Garment_TypeId)}>
                      <DeleteForeverIcon color="error" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={4} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={currentPage} // Use the calculated currentPage value
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0); // Reset the page when rowsPerPage changes
          }}
          mt={2}
        />
      </Container>

      <Grid m={2}>
        {/* add new popup form dialog box */}
        <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} fullWidth>
          <Container component={Paper} elevation={2} sx={{ py: 2 }}>
            <form onSubmit={handleSubmit} noValidate>
              <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mr={1}>
                <Typography variant="h5" textAlign={'left'} pl={2} fontWeight={600} color="primary">
                  {operation} Garment Category
                </Typography>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Stack>
              <Stack direction={'column'} spacing={2} p={2}>
                <TextField
                  type="text"
                  variant="outlined"
                  color="primary"
                  label="Garment Category Description"
                  name="GarmentTypeDescription"
                  value={GarmentTypeDescription}
                  onBlur={handleBlur}
                  onChange={handleInputChange}
                  fullWidth
                  required
                  size="small"
                  error={errors.GarmentTypeDescription}
                  helperText={helperTexts.GarmentTypeDescription}
                  className={isFormSubmitted && errors.GarmentTypeDescription ? 'shake-helper-text' : ''}
                />

                <FormControl size="small" fullWidth component="fieldset">
                  <FormLabel component="legend"> Active </FormLabel>
                  <RadioGroup row value={Active} name="Active" onChange={handleInputChange}>
                    <FormControlLabel value="Y" control={<Radio />} label="Yes" />
                    <FormControlLabel value="N" control={<Radio />} label="No" />
                  </RadioGroup>
                  {errors.Active && (
                    <Typography
                      variant="caption"
                      color="error"
                      className={isFormSubmitted && errors.Active ? 'shake-helper-text' : ''}
                    >
                      {errors.Active && helperTexts.Active}
                    </Typography>
                  )}
                </FormControl>
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  type="submit"
                  sx={{ textTransform: 'capitalize' }}
                >
                  Save
                  {/* {operation} State */}
                </Button>
              </Stack>
            </form>
          </Container>
        </Dialog>

        {/* delete confirmation popup dialog box */}
        <Dialog
          open={openDelete}
          onClose={handleCloseDelete}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullScreen={fullScreen}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle id="alert-dialog-title">{'Are you sure want to Delete?'}</DialogTitle>
          <DialogActions>
            <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
              Cancel
            </Button>
            <Button variant="contained" onClick={() => handleDeleteConfirmed(stateIdToDelete)} color="error" autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>
    </>
  );
};

export default GarmentCategoryMst;
